import { Upload, UploadProps } from 'antd';
import { styled } from 'styled-components';

interface IStyledUpload extends UploadProps {
    position?: string;
}
export const StyledUpload = styled(Upload)<IStyledUpload>`
    .ant-upload-list-item-name {
        width: 160px;
        @media (max-width: 375px) {
            width: 100px;
        }
        overflow: ellipsis;
    }
    .ant-upload-list-item {
        background: transparent !important;
    }
    .ant-upload-list-item:hover {
        background: transparent !important;
    }
    .ant-upload-list-item-action {
        opacity: 1 !important;
    }
    .ant-upload-list {
        position: ${(props: any) => props.position};
        left: 0;
        bottom: -24px;
    }
`;
